<form [formGroup] = "form">
  <h1  *ngIf ="mode ==1" mat-dialog-title> Editing {{data.city}}</h1>
  <h1  *ngIf ="mode ==2" mat-dialog-title> Add City </h1>

  <div mat-dialog-content>
      <mat-form-field style="width:90%; padding-top: 30px;">
        <mat-label>Name:</mat-label>
        <input matInput formControlName = "city">
      </mat-form-field>

      <mat-form-field style="width:90%">
        <mat-label>County:</mat-label>
        <input matInput formControlName = "county">
      </mat-form-field>

      <mat-form-field style="width:90%">
        <mat-label>Climate Zone:</mat-label>
        <input matInput formControlName = "defaultcz">
      </mat-form-field>

      <div style="width: 90%; padding-right: 20px; padding-bottom: 40px;">
        <mat-label>Multiple Climate Zones?  </mat-label>
        <mat-checkbox formControlName = "multiplecz"></mat-checkbox>
      </div>


      <mat-form-field style="width:90%">
        <mat-label>Elevation:</mat-label>
        <input matInput formControlName = "elevation">
      </mat-form-field>

      <mat-form-field>
        <mat-label> State </mat-label>
        <mat-select  formControlName = "state">
          <mat-option *ngFor = "let state of states" [value] = "state.value">
            {{state.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field style="width:90%; padding-bottom: 40px;">
        <mat-label>Region</mat-label>
          <mat-select  formControlName = "region">
            <mat-option *ngFor = "let region of regions" [value] = "region.value">
              {{region.viewValue}}
            </mat-option>
          </mat-select>
      </mat-form-field>


    <br>

  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Close</button>
    <button *ngIf ="mode ==1" mat-button  (click)="save()" [mat-dialog-close]="data" cdkFocusInitial>Save</button>
    <button *ngIf ="mode ==2" mat-button  (click)="add()"  [mat-dialog-close]="data" cdkFocusInitial>Add</button>
  </div>

